/*eslint-disable */
var $ = window.jQuery = require('jquery')

import carousel from 'vue-owl-carousel'
import thumb1 from '@/assets/images/event/thumbnail/webinar_lymphomap_jascap_thumb.jpg';
import thumb2 from '@/assets/images/event/thumbnail/welcoming-pahs-nepal-thumb.jpg';
import thumb3 from '@/assets/images/event/thumbnail/63rd-annual-hematacon-thumb.jpg';
import thumb4 from '@/assets/images/event/thumbnail/lbil-luanch-thumb.jpg';
import thumb5 from '@/assets/images/event/thumbnail/ashray_tmc_thumb.jpg';
import thumb6 from '@/assets/images/event/thumbnail/lymphomap-luanch-thumb.jpg';
import thumb7 from '@/assets/images/event/thumbnail/ai-and-the-future-vishwa-thumb.jpg';
import thumb8 from '@/assets/images/event/thumbnail/pahs-webinar-thumb.jpg';

export default {
  name: 'our-past-event-screen',
  components: {
    carousel
  },
  props: [],
  data () {
    return {
      ourEventData:null,
      // ourEventResults:[
      //   {
      //     title: "Global Lymphoma Awareness Week: Demystifying Lymphoma",
      //     description:"Hosted an international digital conference to kickstart Global Lymphoma Awareness Week. In collaboration with nationally renowned JASCAP Organization in Mumbai.",
      //     publishedAt:"14th September 2023",
      //     thumbnails:thumb1,
      //     query:"",
      //   },
      //   {
      //     title: "Welcoming PAHS Nepal: Discovering Lymphomap",
      //     description:"Welcomed Patan Academy of Health Sciences from Nepal by giving an extensive tour and discussed AI in precision medicine with medical students, experts and clinicians from the institute.",
      //     publishedAt:"17th May 2023",
      //     thumbnails:thumb2,
      //     query:"",
      //   },
      //   {
      //     title: "63rd Annual Haematocon 2022 (India): Indian Society of Haematology and Blood Transfusion",
      //     description:"Team Lymphomap was invited to participate and be a speaker at the 63rd annual Haematocon (2022) in the City of Joy, Kolkata! Hosted by the Indian Society of Hematology and Blood Transfusion.",
      //     publishedAt:"3rd November 2022",
      //     thumbnails:thumb3,
      //     query:"",
      //   },
      //   {
      //     title: "LBIL’s Global Launch Conference",
      //     description:"Celebrated the launch of LBIL, our digital front door for the public, patients, NGOs and support groups.",
      //     publishedAt:"22th July 2022",
      //     thumbnails:thumb4,
      //     query:"",
      //   },
      //   {
      //     title: "Welcoming Ashray TMC: The Warriors of Lymphoma",
      //     description:"  We hosted an extraordinary NGO, Ashray from Tata Medical Center, dedicated to caregivers, patients and brave survivors of Lymphoma",
      //     publishedAt:"26th November 2021",
      //     thumbnails:thumb5,
      //     query:"",
      //   },
      //   {
      //     title: "Lymphomap’s Global Launch Conference",
      //     description:"Celebrated our platform’s launch internationally. We had senior oncologists, experts, and professionals in the medical industry attend and witness how Lymphomap bridges the worlds of Precision Medicine, Oncology, AI and Machine Learning.",
      //     publishedAt:"31st October  2021",
      //     thumbnails:thumb6,
      //     query:"",
      //   },
      //   {
      //     title: "AI and the Future of Computational Radiology",
      //     description:"Hosted a talk led by Dr. Vishwa Parekh – Johns Hopkins University and Medicine",
      //     publishedAt:"12th December 2020",
      //     thumbnails:thumb7,
      //     query:"",
      //   },
      //   {
      //     title: "AI in the Medicine: The Road Ahead",
      //     description:"Hosted a talk led by our founder, Mr. Rahul Bhattacharya on the world of AI in Medicine.",
      //     publishedAt:"7th november 2020",
      //     thumbnails:thumb8,
      //     query:"",
      //   },
      // ]
      ourEventResults:[]
    }
  },
  computed: {
  },
  mounted () {
    this.$store.dispatch('eventListAction').then((res) => {
      this.ourEventData = res.data
      this.ourEventResults = this.ourEventData.data
    })
  },
  methods: {
  },
  watch:{
  },
}